import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificariService {
    private basePath = environment.interop.basePath;

    public downloadEmailUrl = this.basePath + environment.interop.dgaspc.notificari.email.downloadEmail;
    private resendEmailUrl = this.basePath + environment.interop.dgaspc.notificari.email.resendEmail;
    private printNotificariEmailUrl = this.basePath + environment.interop.dgaspc.notificari.email.printNotificari;

    private resendSmsUrl = this.basePath + environment.interop.dgaspc.notificari.sms.resendSMS;
    private printNotificariSmsUrl = this.basePath + environment.interop.dgaspc.notificari.sms.printNotificari;

    constructor(private http: HttpClient) { }

    resendEmail(id: number) {
        return this.http.get(this.resendEmailUrl + id);
    }

    resendSms(id: number) {
        return this.http.get(this.resendSmsUrl + id);
    }

    printNotificariEmail(payload: any) {
        return this.http.post(this.printNotificariEmailUrl, payload, { responseType: 'blob' as 'json' });
    }

    printNotificariSms(payload: any) {
        return this.http.post(this.printNotificariSmsUrl, payload, { responseType: 'blob' as 'json' });
    }
}
